var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "saas_long_image_config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
      },
    },
    [
      _c("div", [_vm._v("示意样式")]),
      _c("el-image", {
        staticClass: "icon",
        attrs: { fit: "contain", src: _vm.icon },
      }),
      _c(
        "el-form-item",
        { attrs: { prop: "type" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 头部配置方式 ")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.type,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "type", $$v)
                },
                expression: "value.config.type",
              },
            },
            [
              _c("el-radio", { attrs: { label: "1" } }, [
                _vm._v("填写名称形式"),
              ]),
              _c("el-radio", { attrs: { label: "2" } }, [
                _vm._v("上传头图形式"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "box" },
        [
          _vm.value.config.type === "1"
            ? [
                _c(
                  "el-form-item",
                  { attrs: { prop: "name" } },
                  [
                    _c("div", { staticClass: "label" }, [_vm._v("头部名称")]),
                    _c("el-input", {
                      attrs: {
                        placeholder: "输入10个字以内的名称",
                        clearable: "",
                      },
                      model: {
                        value: _vm.value.config.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.value.config, "name", $$v)
                        },
                        expression: "value.config.name",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.value.config.type === "2"
            ? [
                _c("div", { staticClass: "title" }, [_vm._v(" 头部图片 ")]),
                _c("el-form-item", { attrs: { prop: "header_image" } }, [
                  _c(
                    "div",
                    { staticClass: "upload-item-wrap" },
                    [
                      _c("upload-file", {
                        ref: "uploadBanner",
                        attrs: {
                          "link-url": _vm.linkUrl,
                          tempurl: _vm.value.config.header_image,
                          canDel: Boolean(_vm.value.config.header_image),
                          deletePadding: true,
                          uploadInfo: _vm.uploadInfo,
                        },
                        on: {
                          onDelete: _vm.onDelete,
                          emitUploadFile: _vm.emitUploadFile,
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "right" },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { margin: "0" },
                              on: {
                                click: function ($event) {
                                  return _vm.onUpload()
                                },
                              },
                            },
                            [_vm._v("上传图片")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v(
                      " 建议尺寸为690*92，支持JPG、PNG等格式，大小不超过2M "
                    ),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "bg_color" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("活动展示区背景色")]),
          _c("el-color-picker", {
            model: {
              value: _vm.value.config.bg_color,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "bg_color", $$v)
              },
              expression: "value.config.bg_color",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "data_source_type",
          attrs: { prop: "data_source_type" },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 长图数据来源模式 ")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.data_source_type,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "data_source_type", $$v)
                },
                expression: "value.config.data_source_type",
              },
            },
            [
              _c(
                "div",
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v("同一数据源"),
                  ]),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v("各长图数据来自相同数据源，只需选择一个活动板块"),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v("独立数据源"),
                  ]),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v("各长图独立设置数据源，可以选择活动板块或活动"),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm.value.config.data_source_type === 2
        ? [
            _vm._l(_vm.value.config.value, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "upload-item" },
                [
                  _c("div", { staticClass: "item-title" }, [
                    _c("span", [_vm._v(" 长图" + _vm._s(index + 1) + " ")]),
                    _vm.value.config.value.length > 1
                      ? _c("i", {
                          staticClass: "el-icon el-icon-delete",
                          on: {
                            click: function ($event) {
                              return _vm.handleDelUpload(index)
                            },
                          },
                        })
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "upload" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "value." + index + ".swipe_image",
                            rules: [
                              { required: true, message: "图片不可为空" },
                            ],
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "upload-item-wrap" },
                            [
                              _c("upload-file", {
                                ref: "uploadBanner",
                                refInFor: true,
                                attrs: {
                                  "link-url": _vm.linkUrl,
                                  tempurl: item.swipe_image,
                                  uploadInfo: _vm.uploadInfo,
                                },
                                on: {
                                  emitUploadFile: function (res) {
                                    return _vm.emitUploadFile(res, index)
                                  },
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "btns" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.onUpload(index)
                                        },
                                      },
                                    },
                                    [_vm._v(" 上传图片 ")]
                                  ),
                                  _vm.pictureList.length > 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectPicture(index)
                                            },
                                          },
                                        },
                                        [_vm._v(" 选择图片 ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "value." + index + ".module_plate_id",
                        rules: [
                          {
                            required: true,
                            message: "菜单类型不可为空",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择板块",
                            clearable: "",
                            filterable: "",
                          },
                          on: {
                            change: function (module_plate_id) {
                              return _vm.changeModule(module_plate_id, item)
                            },
                          },
                          model: {
                            value: item.module_plate_id,
                            callback: function ($$v) {
                              _vm.$set(item, "module_plate_id", $$v)
                            },
                            expression: "item.module_plate_id",
                          },
                        },
                        _vm._l(_vm.moduleList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { prop: "value." + index + ".module_activity_id" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择SaaS活动",
                            clearable: "",
                            filterable: "",
                            disabled: !item.module_plate_id,
                          },
                          on: {
                            change: function (val) {
                              return _vm.changeActivity(val, item)
                            },
                          },
                          model: {
                            value: item.module_activity_id,
                            callback: function ($$v) {
                              _vm.$set(item, "module_activity_id", $$v)
                            },
                            expression: "item.module_activity_id",
                          },
                        },
                        _vm._l(
                          _vm.getActivityList(item.module_plate_id),
                          function (activity) {
                            return _c("el-option", {
                              key: activity.module_activity_id,
                              attrs: {
                                label:
                                  activity.title +
                                  (activity.activity_hall_id
                                    ? "- " + activity.activity_hall_id
                                    : ""),
                                value: activity.module_activity_id,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            _c(
              "el-button",
              {
                staticClass: "el-icon-plus add-upload",
                attrs: { type: "primary" },
                on: { click: _vm.addUpload },
              },
              [_vm._v(" 新增图片")]
            ),
          ]
        : [
            _c(
              "el-form-item",
              { attrs: { prop: "module_plate_id" } },
              [
                _c("div", { staticClass: "label" }, [
                  _vm._v("展示的SaaS活动板块"),
                ]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "请选择板块",
                      clearable: "",
                      filterable: "",
                    },
                    on: {
                      change: function (module_plate_id) {
                        return _vm.changeModule(
                          module_plate_id,
                          _vm.value.config
                        )
                      },
                    },
                    model: {
                      value: _vm.value.config.module_plate_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "module_plate_id", $$v)
                      },
                      expression: "value.config.module_plate_id",
                    },
                  },
                  _vm._l(_vm.moduleList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { prop: "activity_num" } },
              [
                _c("div", { staticClass: "label" }, [
                  _vm._v("展示的SaaS活动个数"),
                ]),
                _c("el-input", {
                  attrs: { clearable: "", placeholder: "请输入" },
                  model: {
                    value: _vm.value.config.activity_num,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "activity_num", $$v)
                    },
                    expression: "value.config.activity_num",
                  },
                }),
              ],
              1
            ),
          ],
      _c(
        "el-form-item",
        { attrs: { prop: "is_check_user" } },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v(" 是否仅展示支持的活动 "),
            _c(
              "span",
              { staticStyle: { "margin-left": "30px", cursor: "pointer" } },
              [
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: { effect: "dark", placement: "top" },
                  },
                  [
                    _c("span", [
                      _vm._v("说明"),
                      _c("i", { staticClass: "new-icon el-icon-info" }),
                    ]),
                    _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                      _c("p", [_vm._v("功能说明：")]),
                      _c("p", [
                        _vm._v(
                          "（1）选中「展示全部活动」，会将所有活动按各版块排规则展示，不论活动是开放式还是封闭式，不论当前账号是否支持；"
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "（2）「仅显示当前用户支持的活动」会将当前用户不在参与范围、被禁用的活动过滤掉，开放式活动未被禁用时视作支持。"
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.is_check_user,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "is_check_user", $$v)
                },
                expression: "value.config.is_check_user",
              },
            },
            [
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("展示全部活动")]),
              _c("el-radio", { attrs: { label: 1 } }, [
                _vm._v("仅显示当前用户支持的活动"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }